import { AppState } from '../root.reducer';

export const getIsEditModalOpen = (state: AppState) => state.user.isEditModalOpen;
export const getOrganizationUserIds = (state: AppState) => state.user.organizationUsers;
export const getOrganizationUsers = (state: AppState) =>
  state.user.organizationUsers.map((userId) => state.entities.user[userId]);
export const getHaveCurrentOrganizationUsersBeenFetched = (state: AppState) => state.user.haveCurrentOrganizationUsersBeenFetched;
export const getBlockedTenant = (state: AppState) => state.user.blockedTenant;
export const getHasFetchedBlockedTenant = (state: AppState) => state.user.hasFetchedBlockedTenant;
export const getIsTenantBlocked = (state: AppState) => !!state.user.blockedTenant;

export const getOrganizationUsersByUserId = (state: AppState, userId: string) => {
  const allOrgUsers = Object.values(state.entities.organizationUser);
  const orgUsersByUserId = allOrgUsers.filter((ou) => ou.userId === userId);
  return orgUsersByUserId.map((ou) => {
    return {
      ...ou,
      user: state.entities.user[userId],
      organization: state.entities.organization[ou.organizationId],
    };
  });
};
